export const patientInformation = [{
        label: 'Name',
        value: 'Arlene Wilson',
    },
    {
        label: 'Primary Contact Number',
        value: ' 45765 04482',
    },
    {
        label: 'Date of Birth ',
        value: ' 12-02-1985',
    },
    {
        label: 'Secondary Contact Number',
        value: '98765 04482',
    },
    {
        label: 'Age',
        value: 38,
    },
    {
        label: 'Address',
        value: 'No.987, Texas, USA',
    },
    {
        label: 'Gender',
        value: 'Female',
    },
]

export const serviceManagement = [{
        label: 'Status',
        value: 'Ongoing',
    },
    {
        label: 'Patient Return Visit',
        value: ' 08/11/2022',
    },
    {
        label: 'Start date and time ',
        value: ' 11/12/2022 00:05',
    },
    {
        label: 'Device ID',
        value: '43829',
    },
    {
        label: 'End date and time ',
        value: ' 11/12/2022 00:05',
    },
    {
        label: 'Low Cell Signal ',
        value: ' No',
    },
    {
        label: 'Study Type ',
        value: ' Holter',
    },
    {
        label: 'RMA ',
        value: ' No',
    },
]

export const studySetting = [{
        label: 'Pre-event Time',
        value: '30 sec',
    },
    {
        label: 'Post-event Time',
        value: '30 sec',
    },
    {
        label: 'Tachycardia Threshold',
        value: '120 bpm',
    },
    {
        label: 'Bradycardia Threshold',
        value: '120 bpm',
    },
    {
        label: 'Pause Level',
        value: '2.5 sec',
    },
    {
        label: 'Diagnosis Lead',
        value: '2',
    },
    {
        label: 'Pause Detection',
        value: 'On',
    },
    {
        label: 'AFib Detection',
        value: 'On',
    },
    {
        label: 'Duration',
        value: '30d 00h 00m',
    },
]

export const referringPhysician = [{
        label: 'Name',
        value: 'Dr. Park Eve',
    },
    {
        label: 'Hospital',
        value: 'Cleveland Clinic',
    },
    {
        label: 'Day phone',
        value: '84897 49992',
    },
    {
        label: 'Address',
        value: 'No.987, Texas, USA',
    },
    {
        label: 'After hours phone',
        value: ' 98897 49992',
    },
    {
        label: 'Fax no',
        value: '2846827',
    },
    {
        label: 'Email',
        value: 'parkeve@gmail.com',
    },
]